/**
 * Histórico exibido na tela Sobre — texto para quem usa o SIAL.
 * Padrão e proibições: .cursor/rules/changelog-usuario-sial.mdc
 * Nova entrada: confirmar a data do dia (não confiar na data sugerida por assistente).
 */
export default [
	{
		date: '04/05/2026',
		changes: [],
		add: [],
		bugfix: [
			'**Estoques / grade:** a coluna Armazém passa a usar o nome enviado pela API (inclusive para armazém inativo), em vez de depender só do catálogo local — evita texto «undefined» quando o navegador não mantém aquele armazém na lista.',
			'**Estoques / gerenciamento e consulta:** linhas com disponível, reservado e bloqueado todos zerados deixam de aparecer na listagem principal — reduz páginas só com saldo zero e alinha a grade ao que há de saldo operacional.',
		],
	},
	{
		date: '03/05/2026',
		changes: [],
		add: [],
		bugfix: [
			'**Armazenamento / filtros:** armazéns inativos deixam de reaparecer em listas locais (ex.: filtro de Posições) após outras telas terem carregado o catálogo completo — o cache do navegador passa a substituir a lista de armazéns por completo a cada carga, e o filtro ignora inativos de forma explícita.',
			'**Armazenamento / combos:** datalists e filtros (incluindo Saídas e exportação CSV) passam a excluir armazém inativo em qualquer ramo da montagem da lista — não só quando o primeiro registro traz `company_id` — e o carregamento por observador (`obs_load_options`) aplica o mesmo critério ao ler o armazém local.',
			'**Estoque / gerenciamento e consulta:** a coluna Posição deixa de aparecer como texto «undefined» quando o catálogo local de posições não foi carregado; o servidor passa a enviar o endereço da posição junto da listagem. O filtro só por posição volta a aplicar corretamente (catálogo de posições carregado antes de resolver rótulos e, sem escopo, todas as posições da credencial).',
			'**Estoque / filtro por posição:** «Contém» e demais operadores de texto deixam de aplicar máscara ampla em código numérico de armazém/posição (que listava quase todo o estoque); passam a filtrar pelo endereço (`location_address`) retornado pela API. Critério por posição com texto não resolvido para ID também é enviado como filtro no endereço.',
			'**Filtros Versa (tabelas dinâmicas):** linhas e campos indexados passam a ser resolvidos só dentro do formulário em uso — evita erros no console («Not found» em `#open-N`, `#value-N`, etc.) e clones na tabela errada quando a página tem outras linhas com a mesma classe (ex.: gerenciamento de estoques).',
			'**Estoque / grade:** quando o servidor não envia texto de posição na linha, o rótulo deixa de ser obtido só pelo catálogo gravado no navegador (evita endereço desalinhado com o que a API considera visível); usa-se referência por armazém e id da posição.',
			'**API / filtros (psycopg 3):** operadores de texto «contém», «começa» e «termina» em listagens com subconsulta + binds (`%s`) passam a escapar corretamente o `%` dos padrões `ILIKE`, evitando erro de SQL ao misturar filtros (ex.: posição por texto + escopo por usuário). Corrige consulta de posições no coletor e demais telas que combinam esse tipo de filtro.',
			'**Coletor / auditoria:** liberação de reserva órfã deixa de falhar com erro interno ao gravar o movimento quando identificadores da empresa vêm como UUID nativo do banco — o registro da transação serializa origem e destino de forma compatível.',
		],
	},
	{
		date: '30/04/2026',
		changes: [
			'**API / consulta de estoque:** nova rota somente leitura para integração externa, com SKU, lote do fabricante, fabricação, validade e quantidades (disponível, reservada e bloqueada) em payload reduzido; permissões alinhadas à consulta de estoque já usada pelos fluxos de integração.',
		],
		add: [],
		bugfix: [
			'**Notas fiscais / saídas:** ao gravar a nota de saída pela atualização completa (equivalente ao PUT na API), o sistema passa a aplicar o mesmo encadeamento já usado na atualização parcial (PATCH): quando a NF está autorizada e vinculada à saída, dispara baixa e encerramento como esperado — evitando saída presa em conferida só porque o cliente usou outro verbo de gravação.',
			'**Pedidos de entrada:** o PDF «Documento do Pedido» passa a seguir o padrão visual do sistema — cabeçalho com logo, referência em destaque, quadros de emitente e destinatário mais legíveis, tabela com larguras fixas e texto que quebra nas descrições — evitando colunas cortadas na margem e nomes de produto truncados.',
			'**Faturamento / saídas:** se a baixa automática após autorização da NF falhar, a gravação da nota passa a retornar erro em vez de concluir em silêncio — permitindo retentativa. O encerramento de saída passa a tentar de novo essa sincronização quando ainda há NF autorizada vinculada e a saída ainda não está «faturada».',
			'**Operações em lote (notas e saídas):** após erro da API (ex.: falha na baixa ou 5xx), deixam de ser exibidos resultados como «0 transmitidos» ou «0 lotes» como se a ação tivesse concluído com sucesso — o aviso de erro continua e a grade não avança com mensagem enganosa.',
			'**Saídas / baixa:** quando a saída ainda não está «faturada» (70), a resposta de «Dar baixa» passa a explicar o motivo (falta de conferência, NF não vinculada ou autorizada no cadastro, etc.) em vez de só «Aguardando faturamento».',
			'**Saídas / faturamento:** ao usar «Gerar notas» (emitir NF) para uma saída, o sistema passa a marcar a saída como «Faturando» (65); após a autorização da NF no lote, a sequência de baixa no estoque, «Faturada» (70) e encerramento (90) continua automática como antes.',
			'**Estoque / NF e lotes:** quando a baixa não encontra linha de estoque na posição (reserva→saída), a mensagem passa a orientar sobre causas prováveis e mostra SKU e endereço da posição, em vez de apenas códigos internos.',
			'**Coletor / auditoria:** correção interna para o cadastro de pendências não falhar ao iniciar quando o modo DDL automática de repositório está desligado — as tabelas continuam obrigatórias via migrações do ambiente.',
		],
	},
	{
		date: '29/04/2026',
		changes: [
			'**Saídas / integridade:** reforço de banco impede gerar ou alterar saída operacional pré-faturamento com quantidade maior que o pedido por produto, incluindo atendimentos divididos em mais de um lote.',
			'**Operação / batch:** o script `reconcile_output_items_to_order_batch.py` alinha a grade ao pedido: linha única inflada, remoção de linhas excedentes e, quando o excesso não fecha em linhas inteiras, corte parcial de quantidade por produto/lote (casos “dobrados” por bug); `--no-trim-inflation` desliga só o primeiro passo; só pré-faturamento.',
			'**Coletor / auditoria:** nova correção auditada permite recompor reserva insuficiente de saída operacional quando há saldo disponível na posição/lote, registrando o movimento L→R e a pendência de auditoria correspondente.',
		],
		add: [],
		bugfix: [
			'**Saídas / pedido:** a validação na API impede gravar grade cuja soma por produto ultrapassa o pedido mesmo quando o critério por lote não fecha sozinho — proteção extra ao lado do bloqueio já aplicado no banco.',
			'**Coletor / auditoria:** gravação da aprovação supervisionada passa a serializar corretamente valores em detalhes da ação (evita erro interno ao confirmar com payload complexo).',
			'**Coletor / auditoria:** registro de pendências e observações na auditoria deixa de retornar permissão negada no servidor — perfis com acesso ao vínculo reserva/pedido passam a poder gravar pendências conforme o cadastro de permissões.',
			'**Coletor / auditoria:** a lista de saldos negativos passa a mostrar apenas inconsistência operacional atual, evitando exibir resíduos históricos de saídas já encerradas ou sem reserva negativa real no estoque.',
			'**Grupos / permissões:** o perfil Supervisor de auditoria passa a receber explicitamente (por UUID do grupo) os endpoints de pendências do coletor, para não depender do nome exibido no cadastro.',
			'**Saídas / integridade:** quando o banco bloqueia gravação ou estorno porque a grade ultrapassa o pedido (proteção por produto ou por lote), a mensagem ao usuário passa a ser em português claro, com pedido, produto e quantidades permitidas — em vez do texto técnico do PostgreSQL.',
			'**Gerenciamento de estoque:** divisão de saldo com isolamento em novo lote passa a criar a linha já no lote isolado, evitando erro de duplicidade de célula/lote.',
			'**Notas fiscais / lotes:** «Ver notas do lote» monta o quadro só com o JSON do próprio lote (sem outras chamadas por NF), usando texto criado no navegador com `createElement`/`textContent` — assim mensagens ou trechos que lembram marcação não quebram o HTML do aviso nem deixam o modal em branco.',
		],
	},
	{
		date: '28/04/2026',
		changes: [
			'**Estoque / bloqueios:** novas naturezas de bloqueio para diferenciar produto não localizado, quantidade divergente e produto em posição incorreta, permitindo relatório e tratativa por motivo.',
			'**Coletor / auditoria:** novas rotas para consultar vínculo reserva/pedido, liberar reserva órfã com lançamento compensatório e listar casos de extrato negativo para investigação.',
			'**Kardex BI:** filtro de lote passa a aceitar busca pelo lote do fabricante, e os relatórios exibem o lote do fabricante nas linhas.',
			'**Notas fiscais:** tela de lotes de NF ganha resumo das notas vinculadas, filtros por NF/chave/retorno e detalhe das notas internas do lote para apoiar tratativas de rejeições SEFAZ.',
		],
		add: [
			'**Naturezas de bloqueio:** AUDIT_NAO_LOCALIZADO, AUDIT_QTD_DIVERGENTE, AUDIT_POSICAO_INCORRETA e AUDIT_RESERVA_ORFA.',
			'**Supervisor de auditoria:** perfil e aprovação supervisionada para ações críticas do coletor.',
		],
		bugfix: [
			'**Coletor / auditoria:** aprovação supervisionada aceita o login do supervisor informado no coletor e corrige falha interna ao liberar reserva órfã.',
			'**Coletor / auditoria:** liberação de reserva órfã passa a aceitar ausência de pedido vinculado, mantendo auditoria da ação e bloqueando a operação se existir reserva ativa ligada a saída.',
			'**Coletor / auditoria:** consulta de vínculo reserva/pedido passa a aceitar modo de varredura sem produto/lote/posição, retornando células com reserva para análise de órfãs.',
		],
	},
	{
		date: '27/04/2026',
		changes: [
			'**Integração (TechHub / fila de faturas):** ajuste para evitar faturas que deixavam de ser reprocessadas quando o contador de tentativas alcançava o limite — a fila volta a tratar o documento de forma previsível após novos envios da integração ou no processamento agendado.',
		],
		add: [],
		bugfix: [
			'**Integração (TechHub / fila de faturas):** situação em que o pedido não era gerado e o registro permanecia preso com status de fila ainda aberto, apesar de novas consultas na origem mostrando a fatura — fluxo alinhado ao reprocessamento correto.',
		],
	},
	{
		date: '25/04/2026',
		changes: [
			'**Faturamento / saídas:** depois que a nota de saída é autorizada, o sistema aplica a baixa da reserva antes de consolidar os status da saída, no mesmo sentido do encerramento que a operação já utiliza — reduz divergência entre o que consta como faturado e o movimento no acompanhamento de estoque.',
			'**Pedidos de saída:** no menu de relatórios, exportar a listagem de pedidos em planilha (CSV), com opção de aplicar os mesmos filtros e ordem da tela ou exportar tudo a que o seu usuário tem acesso.',
		],
		add: [],
		bugfix: [
			'**Estoque / saídas faturadas:** situação em que a saída podia aparecer faturada sem a baixa correspondente no extrato, em fluxos ligados à nota; sequência de processamento alinhada ao encerramento manual.',
			'**Entradas:** ao cancelar ou inativar, o sistema não exige mais que o armazém de recebimento continue ativo (ex.: após desativar o armazém e ainda existir entrada pendente).',
		],
	},
	{
		date: '24/04/2026',
		changes: [
			'**Banco de dados:** complemento da proteção que passa a registrar corretamente no histórico as alterações em itens de saída.',
			'**Operação:** ajuste de quantidades em uma saída após situação irregular de regeração de linhas; saldo e movimentos conferidos.',
		],
		add: [],
		bugfix: [],
	},
	{
		date: '23/04/2026',
		changes: [
			'**Banco de dados:** histórico de alterações nos itens da saída e regra que evita aumentar quantidade além do que o estoque comprova para aquela saída.',
			'**Operação:** correção de saldo disponível após cancelamentos que tinham deixado diferença residual.',
			'**Conferência de saída:** o relatório passa a refletir quem conferiu a saída, e não apenas o último usuário que alterou o pedido.',
			'**Etiqueta de expedição:** na linha de endereço, exibição do CEP após cidade e UF.',
			'**Etiqueta de posição:** leitura do código alinhada ao uso no coletor (endereço compacto, sem dados técnicos extras).',
		],
		add: [],
		bugfix: [
			'**Coletor / saídas:** ao salvar, o sistema ignora campos de conferência enviados no retorno da tela, evitando erro ao gravar.',
			'**Autenticação:** correção grave em que, em alguns casos de uso simultâneo, o nome do usuário gravado em movimentos podia ser o de outra sessão.',
		],
	},
	{
		date: '22/04/2026',
		changes: [
			'**BI — Auditoria:** novo relatório em planilha com visão de entradas, saídas ou estoque, filtros e abas de resumo, histórico e movimentos.',
			'**BI — Bloqueios:** novo relatório que descreve posições e lotes bloqueados ou reservados, com modo de exibição mais claro e menos ruído.',
			'**Tela:** carregamentos longos (exportações grandes) passam a mostrar barra de progresso até o fim do processamento.',
			'**Estoque:** colunas e mensagens passam a usar o termo «bloqueada» de forma consistente em telas e relatórios.',
		],
		add: [
			'**BI:** relatórios de Auditoria e de Bloqueios descritivo, conforme permissão do seu perfil.',
		],
		bugfix: [
			'**Navegação:** após login com link direto para uma tela, a área de trabalho passa a abrir a tela correta sem precisar clicar de novo no menu.',
			'**Estoque — gerenciamento:** trava após confirmar ação e proteção contra envio em duplicidade ao bloquear, desbloquear ou movimentar em lote.',
		],
	},
	{
		date: '21/04/2026',
		changes: [
			'**Pedidos de saída:** aviso e bloqueio ao tentar reutilizar a mesma referência em outro pedido ainda ativo.',
			'**Saídas:** opção e rotina de correção quando, em casos legados, a saída ficou com o dobro do previsto no pedido.',
			'**Posições:** possível alterar o armazém de uma posição pelo cadastro, quando regras de estoque permitem.',
			'**Relatório (rastreio de saldo):** exibição do endereço da posição em vez de códigos internos.',
			'**Estoque:** reforço contra linhas duplicadas de saldo e contra alocação duplicada na mesma célula.',
		],
		add: [],
		bugfix: [],
	},
	{
		date: '20/04/2026',
		changes: [
			'**Saídas:** relatório de rastreio de saldo com opção de exportar em tabela, além do PDF; conferência ajustada para limites do pedido e totais coerentes.',
			'**Saídas:** tela de edição deixa de recarregar itens a partir do pedido de entrada no fluxo errado, evitando linhas indevidas.',
			'**Saídas:** regras de teto do pedido por produto e lote; cancelamento e baixa com melhor alinhamento à reserva real.',
			'**Faturamento:** após a nota, o processamento da baixa fica em ordem mais segura (evita saída faturada sem movimento de estoque correspondente).',
			'**Integração (pedido / ERP):** cancelamento coordenado passa a registrar o resultado de forma acompanhável; integrações diversas com mais mensagens claras em falha.',
		],
		add: [],
		bugfix: [
			'**BI / Kardex:** correção de erro na montagem de consultas em ambiente de banco mais recente.',
		],
	},
	{
		date: '19/04/2026',
		changes: [
			'**Armazéns:** possível inativar armazém vazio; armazéns inativos deixam de aparecer em listas de operação e bloqueiam novas movimentações indevidas.',
			'**Formulários:** ajuste em que valor numérico «0» não marcava opção indevidamente no cadastro do armazém.',
		],
		add: [],
		bugfix: [],
	},
	{
		date: '18/04/2026',
		changes: [
			'**Empresas / Entradas:** parámetro «Entrada com coletor» restringe a escolha de destino, armazém e posição à lista.',
			'**Entradas — grade:** colunas e ordenação alinhadas aos dados; melhor suporte a conferência e programa.',
			'**BI / Kardex:** origem e destino exibem endereço e nomes, não apenas identificação técnica.',
			'**Posições:** etiqueta e tela de catálogo com ajustes de leitura e de carregamento em volumes grandes.',
			'**Movimentação:** opção de mover só o saldo livre quando houver reserva na posição.',
		],
		add: [],
		bugfix: [
			'**Login:** tela de entrada com logotipo e texto institucional conforme o ambiente do cliente.',
			'**Saídas — posição na tela:** lista de endereços completa e consistente com o remetente e armazém escolhidos.',
			'**Saídas — mensagens:** textos de erro orientam a corrigir cadastro ou conferir estoque, sem códigos internos em destaque.',
		],
	},
	{
		date: '17/04/2026',
		changes: [
			'**Pedidos e saídas:** evita duas saídas vivas para o mesmo pedido; reforço de geração e mescla de linhas no mesmo endereço e lote.',
			'**Conferência:** na conferência da saída, a reserva passa a ir para a posição de expedição padrão do armazém, quando aplicável na operação do cliente.',
			'**Faturamento:** leitura do status da nota após a autorização evita falha intermitente no disparo da baixa.',
		],
		add: [],
		bugfix: [
			'**Posições — cadastro:** ao trocar de empresa no formulário, o endereço salvo deixa de ir para a URL errada (evitava gravar a posição).',
		],
	},
	{
		date: '16/04/2026',
		changes: [
			'**Pedidos (entrada e saída) — programa, NF no pedido e relatórios; integração com geração de nota e fiel depositário.**',
			'**Estoque — BI, Kardex, bloqueios, linhas de saída, catálogo de posições e gerenciamento em lote; permissões associadas para perfis de estoque e administradores.**',
			'**Movimentação e lotes: bloqueio automático e rotinas de vencimento; NF-e: tributação e inutilização conforme regras vigentes.**',
		],
		add: [
			'**Relatórios e rotinas** citados acima, conforme o que o administrador habilitou para o seu grupo.',
		],
		bugfix: [
			'**Geração de saída:** cálculo de atendimento e alocação de estoque mais estáveis; pedido parcial e flags de lote ajustados.',
		],
	},
	{
		date: '10/04/2026',
		changes: [
			'**Embalagens e cadastros:** exportação e relatórios; consulta e validação de telefone e endereço em cadastros.',
			'**NF-e e pedidos:** travas e validações de nota, destinatário e eventos; melhor apresentação de valores e totais no aviso de remessa.',
			'**Estoque — grade:** colunas e preferências alinhadas ao que o operador vê e exporta.',
		],
		add: [],
		bugfix: [],
	},
	{
		date: '01/04/2026',
		changes: [
			'**Entradas:** relatório completo e fluxo de NF do pedido para a entrada; vinculação automática do número da nota quando fizer sentido.',
			'**BI / Kardex:** análise de movimentos com custo opcional; filtros e desempenho em bases grandes.',
			'**Estoque:** bloquear quantidade com motivo e natureza; mover toda a posição quando não há reserva; BI analítico de estoque completo.',
			'**Empresas e NF-e:** textos padrão no corpo da nota, benefício fiscal SP em medicamentos, ajuste de saída em fiel depositário e cancelamento de saída com baixa já registrada.',
		],
		add: [
			'**Módulo BI** ampliado (Kardex, estoque analítico) e ferramentas de relato em entrada, conforme permissão.',
		],
		bugfix: [
			'**Correções** de filtro, produto e tela de Kardex; cancelamento de saída faturada com estorno de baixa de estoque orquestrado de forma segura.',
		],
	},
	{
		date: '20/03/2026',
		changes: [
			'**Entradas e saídas — conferência:** relatórios alinhados ao padrão do picking, mais legíveis e completos.',
			'**DANFE (layout Protheus):** descrição e quebras de página melhor em dados longos.',
			'**Derrubada de pallets, etiquetas, picking (FEFO) e lote a vencer:** ajustes de regra, layout e bloqueio de lote indevido na separação.',
		],
		add: [
			'**Rotina automática** (quando o cliente usa) para marcar lotes em janela de vencimento curto, conforme política de estoque.',
		],
		bugfix: [
			'**Conferência e impressões:** permissões, lista de produto no relatório de entrada, endereço vazio na derrubada de pallets.',
		],
	},
	{
		date: '10/03/2026',
		changes: [
			'**Importação e clientes:** planilha de clientes com mais campos, relatório de cadastro e atalhos (CEP, município).',
			'**Pedidos de saída:** resultados de geração mais completos; desconto e totais; central de importação reforçada.',
		],
		add: [],
		bugfix: [
			'**Picking e pedidos de saída:** cálculo de atendimento com lista de códigos parciais, lotes e preços; várias correções de salvamento de linha.',
		],
	},
	{
		date: '25/02/2026',
		changes: [
			'**Aviso de remessa:** assinatura permanece na mesma página do quadro de itens.',
		],
		add: [],
		bugfix: [
			'**Coletor e relatórios de conferência** com consultas ajustadas após evolução do cadastro de usuário.',
		],
	},
	{
		date: '19/02/2026',
		changes: [
			'**Programa (vínculo contábil / gestão):** colunas e filtros em pedidos, entradas, saídas e estoque; tela Sobre com histórico de mudanças recentes.',
		],
		add: [
			'**Controle** de programa padrão e normalização de dados legados, conforme módulo e empresa.',
		],
		bugfix: [
			'**Listagens, etiquetas e impressos** vinculados a permissão e a cadastro de empresa.',
		],
	},
	{
		date: 'Até 18/02/2026 (histórico resumido)',
		changes: [
			'**Quando o módulo existir no seu contrato:** transportador em modo entrega local, aviso de remessa e pick list reformulados, inutilização de nota, NF de ativo imobilizado, CFOPs e observações fiscais, etiquetas e entrada detalhada, melhorias no coletor e no fluxo de separação e conferência.',
		],
		add: [],
		bugfix: [
			'**Correções** gerais de telas, NF-e, coletor e conferência, descritas nas versões anteriores às acima; consulte a equipe se precisar de detalhe de chamado em arquivo interno.',
		],
	},
];
